import { useDailyConstraints } from '~/clients/optimus-view-queries.generated'

import { useSentryLogging } from '../../../shared/useSentryLogging'

export const useDailyEquipmentConstraintsQuery = () => {
    const query = useDailyConstraints({ select: data => data.constraints })

    useSentryLogging({ key: 'useDailyEquipmentConstraintsQuery', queryResult: query })

    return query
}
